/**
 * 创建一个带工具方法的枚举辅助对象
 */
export const createEnumHelper = <
  T extends Record<string, number | string>,
  L extends Record<keyof T, string>,
>(
  enumObj: T,
  labels: L,
) => {
  type Key = keyof T;
  // type Code = T[Key];

  /** 根据 code 获取 key */
  const getKeyByCode = (code: number): Key | null => {
    const entry = Object.entries(enumObj).find(([, v]) => v === code);
    return entry ? (entry[0] as Key) : null;
  };

  /** 获取中文文本 */
  const getText = (code: number): string => {
    const key = getKeyByCode(code);
    return key ? labels[key] : "-";
  };

  /** 生成 options */
  const options = (Object.keys(enumObj) as Key[]).map((key) => ({
    label: labels[key],
    value: enumObj[key], // <-- 这里 TS 会推断为 Code
  }));

  return {
    enumObj,
    labels,
    getKeyByCode,
    getText,
    options,

    // /** 类型导出 */
    // typeKey: null as unknown as Key,
    // typeCode: null as unknown as Code,
  };
};
